import { canv } from "@/canv/global.js";
import { wmBase } from "@/widgetMenu/wmBase";

const GROUP_SVG = `
<svg width="23" height="23" viewBox="0 0 145 146" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="10" width="128" height="128" rx="3" fill="#545454"/>
    <rect x="17" y="19" width="110" height="110" rx="3" fill="white"/>
    <rect x="35" y="36" width="50" height="50" rx="1" fill="#545454"/>
    <rect x="60" y="61" width="50" height="50" rx="1" fill="#545454"/>
    <rect x="129" width="16" height="16" fill="#545454"/>
    <rect x="129" y="130" width="16" height="16" fill="#545454"/>
    <rect width="16" height="16" fill="#545454"/>
    <rect y="129" width="16" height="16" fill="#545454"/>
</svg>`;

const UNGROUP_SVG = `
<svg width="23" height="23" viewBox="0 0 125 130" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="7" y="7" width="80" height="80" rx="1" fill="#545454"/>
    <rect x="16" y="16" width="62" height="62" rx="1" fill="white"/>
    <rect width="14" height="14" fill="#545454"/>
    <rect x="80" y="1" width="14" height="14" fill="#545454"/>
    <rect x="80" y="80" width="14" height="14" fill="#545454"/>
    <rect y="80" width="14" height="14" fill="#545454"/>
    <rect x="38" y="43" width="80" height="80" rx="1" fill="#545454"/>
    <rect x="47" y="52" width="62" height="62" rx="1" fill="white"/>
    <rect x="31" y="36" width="14" height="14" fill="#545454"/>
    <rect x="111" y="37" width="14" height="14" fill="#545454"/>
    <rect x="111" y="116" width="14" height="14" fill="#545454"/>
    <rect x="31" y="116" width="14" height="14" fill="#545454"/>
</svg>`;

export class WmGroup extends wmBase {
    build() {
        if (canv.canvasController.selected.length === 1) {
            return `
            <div class="wm_group" data-action="ungroup" title="Разгруппировать">
                ${UNGROUP_SVG}
            </div>
            `;
        }

        // если среди выбранных есть элемент с parent - не даем дальше группировать
        // если среди выбранных есть сгруппированные элементы, то показываем разгруппировать и сгруппировать
        // если среди выбранных нет сгруппированных элементов, то показываем только сгруппировать
        const hasGrouped =
            canv.canvasController.selected.findIndex((item) => !item.isItemWrapper()) !== -1;
        const hasBeenGrouped =
            canv.canvasController.selected.findIndex((item) => item.parent) !== -1;

        return `
            ${
                !hasBeenGrouped
                    ? `
                <div class="wm_group" data-action="group" title="Сгруппировать">
                    ${GROUP_SVG}
                </div>
                `
                    : ""
            }
            ${
                hasGrouped
                    ? `
                <div class="wm_group" data-action="ungroup" title="Разгруппировать">
                    ${UNGROUP_SVG}
                </div>
            `
                    : ""
            }
            `;
    }

    init() {
        const items = document.querySelectorAll<HTMLElement>(".wm_group");
        items.forEach((item) => {
            item.removeEventListener("mouseup", this.itemClick, false);
            item.addEventListener("mouseup", this.itemClick, false);
        });
    }

    itemClick = (e: MouseEvent) => {
        const action = (e.currentTarget as HTMLElement)?.getAttribute("data-action");
        if (!action) {
            return;
        }
        canv.canvasController.groupProccessor(action === "group" ? "group" : "ungroup");
    };

    name = "wm_group";
}
